<script lang="ts">
export default {
  name: 'AccountProgramDetailTabs',
};

export interface DetailTab {
  title: string;
  value: string;
  chipTitle?: string;
}
</script>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  selectedTab: string;
  tabs: DetailTab[];
}>();

const emit = defineEmits<{
  (e: 'change', value: string): void;
}>();

const selected = ref<string>(props.selectedTab);

</script>

<template>
  <div class="tw:flex tw:justify-center">
    <div class="tw:join tw:justify-center tw:pt-4">
      <input v-for="tab in tabs" :key="tab.value"
             type="radio" name="accountProgramDetailTabOptions" :aria-label="tab.title"
             class="tw:join-item tw:btn tw:btn-sm"
             :checked="selected === tab.value"
             @click="emit('change', tab.value)" />
    </div>
  </div>
</template>
